/**
 * numbersForPaginationLinks
 *
 * Generates an array of numbers to display pagination links for.
 * Implements a "sliding-window" style of page numbers to display.
 * Ex. If there are 50 pages of results, and we only want to show 5 links at a time:
 *  - On page 1: [_1_, 2, 3, 4, 5]
 *  - On page 8: [6, 7, _8_, 9, 10]
 *  - On page 49: [46, 47, 48, _49_, 50]
 *
 * The algorithm works recursively. The function takes a `numbers` array containing
 * page numbers to link to (initially empty). Each call checks the base case: if the length
 * of the collected numbers has grown to equal the maxLength or totalPages, it's done, return it.
 * Otherwise, each call will try to add a number to the front and back of the collection,
 * "expanding" the collection until it hits the walls of the minimum page number (1) or max page
 * number (totalPages).
 */
export default function numbersForPaginationLinks(
  pageNum,
  totalPages,
  maxLength = 5,
  numbers = []
) {
  // Base Case: The numbers array is as long as either the totalPages or maxLength
  if (numbers.length === Math.min(maxLength, totalPages)) {
    return numbers;
  }

  // First Case: If there are no numbers in the array yet, add the current pageNum and recurse.
  if (numbers.length === 0) {
    return numbersForPaginationLinks(pageNum, totalPages, maxLength, [pageNum]);
  }

  // If we can add a number to the beginning, add it.
  const firstElementValue = numbers[0];
  if (firstElementValue > 1) {
    numbers.unshift(firstElementValue - 1);
  }

  // If we can add a number to the end, add it.
  const lastElementValue = numbers[numbers.length - 1];
  if (lastElementValue < totalPages) {
    numbers.push(lastElementValue + 1);
  }

  // Now recurse.
  return numbersForPaginationLinks(pageNum, totalPages, maxLength, numbers);
}

// Here is an iterative algorithm that accomplishes the same thing.

// export default function numbersForPaginationLinks(pageNum, totalPages, maxLength = 5) {
//   let upperLimit = pageNum;
//   let lowerLimit = pageNum;

//   for (let i = 1; i < maxLength && i < totalPages;) {
//     if (lowerLimit > 1) {
//       lowerLimit--;
//       i++;
//     }
//     if (i < maxLength && upperLimit < totalPages) {
//       upperLimit++;
//       i++;
//     }
//   }

//   let numbers = [];
//   for (let i = lowerLimit; i <= upperLimit; i++) {
//     numbers.push(i);
//   }

//   return numbers;
// }
